/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductNonInventoryPart
 */
export interface ProductNonInventoryPart {
    /**
     * 
     * @type {string}
     * @memberof ProductNonInventoryPart
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductNonInventoryPart
     */
    name?: string;
}

/**
 * Check if a given object implements the ProductNonInventoryPart interface.
 */
export function instanceOfProductNonInventoryPart(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProductNonInventoryPartFromJSON(json: any): ProductNonInventoryPart {
    return ProductNonInventoryPartFromJSONTyped(json, false);
}

export function ProductNonInventoryPartFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductNonInventoryPart {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function ProductNonInventoryPartToJSON(value?: ProductNonInventoryPart | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
    };
}

